import type { RootState } from '../reducers/rootReducer.ts';
import type { IDProcessState } from '../models/dialogs/dialogProcess.ts';

export const dialogProcessorSelector = (state: RootState): IDProcessState => state.dialogProcessorReducer;

export const isLastBlockSelector = (state: RootState): boolean =>
  !!state.dialogProcessorReducer.blocks.currentBlock?.isEnd;

export const sessionIdSelector = (state: RootState): string => state.dialogProcessorReducer.sessionId;
